import { toast } from "react-toastify";
import { formatDateFn } from "../common/formatDateForAPI";
import { buildFiltersArray } from "../common/buildSearchFilters";
import { requestBackendReportExport } from "./backendReportExport";

export const HISTORY_LOG_GRANULAR_REPORT_TYPE = "HISTORY_LOG_GRANULAR";

export function buildHistoryLogsExportQueryBody({
  activeFilters = [],
  sortField = "created_at",
  sortDirection = "desc",
  calendarDate,
  searchTypeOptions = [],
}) {
  const isTrackingIdSearch = activeFilters.some(
    (filter) =>
      filter.searchType === "tracking_id" && Boolean(filter.searchText?.trim())
  );

  const queryBody = {
    order_by: sortField,
    sorting_order: String(sortDirection).toUpperCase(),
  };

  if (!isTrackingIdSearch && calendarDate?.[0]) {
    queryBody.start_date = formatDateFn(calendarDate[0].startDate);
    queryBody.end_date = formatDateFn(calendarDate[0].endDate);
  }

  const filters = buildFiltersArray(activeFilters, searchTypeOptions);
  if (filters.length) {
    queryBody.filtering = JSON.stringify(filters);
  }

  return queryBody;
}

export async function exportHistoryLogsReport({
  clientId,
  userPlatform = "amazon",
  triggeredBy,
  totalCount,
  queryBody,
  frontendConfig = {},
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: HISTORY_LOG_GRANULAR_REPORT_TYPE,
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        include_summary_row: false,
        ...frontendConfig,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message ?? "Failed to submit export request."
    );
  } finally {
    setIsExporting(false);
  }
}
